import api from ".";

interface EquipmentData {
  id?: number;
  name: string;
  model: string;
  serial_number: string;
  brand: string;
  technician: string;
  calibration_date: string;
  expiration_date: string;
  pdf_file?: File | null;
}

interface CustomerData {
  name: string;
  document: string;
  contact_name: string;
  phone: string;
  email: string;
  equipment: EquipmentData[];
}

export const createClientWithEquipment = async (data: CustomerData) => {
  const token = localStorage.getItem("uniservice_token");

  try {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("document", data.document);
    formData.append("contact_name", data.contact_name);
    formData.append("phone", data.phone);
    formData.append("email", data.email);

    data.equipment.forEach((eq, index) => {
      formData.append(`equipment[${index}][name]`, eq.name);
      formData.append(`equipment[${index}][model]`, eq.model);
      formData.append(`equipment[${index}][serial_number]`, eq.serial_number);
      formData.append(`equipment[${index}][brand]`, eq.brand);
      formData.append(`equipment[${index}][technician]`, eq.technician);
      formData.append(
        `equipment[${index}][calibration_date]`,
        eq.calibration_date
      );
      formData.append(
        `equipment[${index}][expiration_date]`,
        eq.expiration_date
      );
      if (eq.pdf_file) {
        formData.append(
          `equipment[${index}][pdf_file]`,
          eq.pdf_file,
          eq.pdf_file.name
        );
      } else {
        formData.append(`equipment[${index}][pdf_file]`, "");
      }
    });

    const response = await api.post("/api/v1/customers", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Erro ao criar cliente:", error.response?.data || error);
    throw error;
  }
};

export const getAllCustomersAndEquipments = async () => {
  const token = localStorage.getItem("uniservice_token");
  try {
    const response = await api.get("/api/v1/customers", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Ocorreu um erro ao carregar lista de usuários.", error);
  }
};

export const getCustomer = async (customerId: string) => {
  const token = localStorage.getItem("uniservice_token");

  try {
    const url = `/api/v1/customers/${customerId}`;

    const response = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    return response;
  } catch (error: any) {
    console.error(
      "Ocorreu um erro ao carregar o cliente.",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const updateCustomer = async (
  customerId: string,
  data: CustomerData
) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/customers/${customerId}`;

  try {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("document", data.document);
    formData.append("contact_name", data.contact_name);
    formData.append("phone", data.phone);
    formData.append("email", data.email);
    formData.append("_method", "PUT");
    data.equipment.forEach((eq, index) => {
      if (eq.id) formData.append(`equipment[${index}][id]`, String(eq.id));
      formData.append(`equipment[${index}][name]`, eq.name);
      formData.append(`equipment[${index}][model]`, eq.model);
      formData.append(`equipment[${index}][serial_number]`, eq.serial_number);
      formData.append(`equipment[${index}][brand]`, eq.brand);
      formData.append(`equipment[${index}][technician]`, eq.technician);
      formData.append(
        `equipment[${index}][calibration_date]`,
        eq.calibration_date
      );
      formData.append(
        `equipment[${index}][expiration_date]`,
        eq.expiration_date
      );

      if (!eq.id) {
        if (eq.pdf_file instanceof File) {
          formData.append(
            `equipment[${index}][pdf_file]`,
            eq.pdf_file,
            eq.pdf_file.name
          );
        } else {
          throw new Error(
            `O arquivo PDF é obrigatório para o equipamento "${
              eq.name || `#${index + 1}`
            }".`
          );
        }
      } else if (eq.pdf_file instanceof File) {
        formData.append(
          `equipment[${index}][pdf_file]`,
          eq.pdf_file,
          eq.pdf_file.name
        );
      }
    });

    const response = await api.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Erro ao atualizar cliente:", error.response?.data || error);
    throw error;
  }
};

export const deleteCustomer = async (customerId: string) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/customers/${customerId}`;

  try {
    const response = await api.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Erro ao excluir cliente.", error);
  }
};
